import type { FC } from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';

import DiffIndicator from './components/DiffIndicator';

import { styles } from './index.styles';

export interface NumberDifferenceProps extends TypographyProps {
  comparisonDiff?: number | null;
  showAbsolute?: boolean;
  showArrow?: boolean;
  hidePlusMinus?: boolean;
  centerEmpty?: boolean;
}

const NumberDifference: FC<NumberDifferenceProps> = ({
  comparisonDiff,
  showAbsolute = false,
  showArrow = false,
  hidePlusMinus = false,
  centerEmpty = false,
  sx = [],
  ...props
}) => (
  <Typography
    className="NumberDifference-root"
    component="span"
    sx={[
      styles.numberDifference(comparisonDiff),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...props}
  >
    {typeof comparisonDiff === 'number' ? (
      <>
        {/* When centerEmpty = true, 0 values will be centered, not pushed */}
        {/* off-center by the invisible CircleIcon placeholder */}
        {showArrow && !(centerEmpty && comparisonDiff === 0) && (
          <DiffIndicator comparisonDiff={comparisonDiff} />
        )}

        {comparisonDiff > 0 && !showAbsolute && '+'}

        {comparisonDiff === 0 && !showAbsolute && !hidePlusMinus && <>±</>}

        {showAbsolute ? Math.abs(comparisonDiff) : comparisonDiff}
      </>
    ) : (
      <>
        {/* Used as a placeholder when not showing up arrow or down arrow. */}
        {showArrow && !centerEmpty && <CircleIcon style={{ opacity: 0 }} />}
        --
      </>
    )}
  </Typography>
);

export default NumberDifference;
